import React, { FC, useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import classes from './VideoPlayer.module.scss';
import { queueScreenPlayBtnIcon } from '../../../../assets/icons';
import classNames from 'classnames';
import {
  isQueueScreenVideoAutoplayEnabled,
  isQueueScreenVideoSoundEnabled
} from '../../../../constants/API';

type VideoPlayerProps = {
  videoPlaylist?: string[] | null;
  isPauseVideo: boolean;
  volume: number;
  noRoundedCorners?: boolean;
};

const VideoPlayer: FC<VideoPlayerProps> = ({
  videoPlaylist,
  isPauseVideo,
  volume,
  noRoundedCorners
}) => {
  const playlist = videoPlaylist ?? [];
  const [isPlaying, setIsPlaying] = useState(isQueueScreenVideoAutoplayEnabled);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [isUserInteracted, setIsUserInteracted] = useState(isQueueScreenVideoSoundEnabled);
  const normalizedVolume = Number.isFinite(volume) ? Math.min(1, Math.max(0, volume)) : 0.2;
  const isMuted = !isQueueScreenVideoSoundEnabled || !isUserInteracted;

  const handlePlayNextVideo = () => {
    setCurrentVideoIndex((prevIndex) =>
      playlist.length === 0 ? 0 : prevIndex === playlist.length - 1 ? 0 : prevIndex + 1
    );

    if (isQueueScreenVideoAutoplayEnabled) {
      setIsPlaying(true);
    }
  };

  const handlePlayPause = () => {
    if (isQueueScreenVideoSoundEnabled) {
      setIsUserInteracted(true);
    }
    if (isPlaying) {
      setIsPlaying(false);
    } else {
      setIsPlaying(true);
    }
  };

  useEffect(() => {
    if (!isPauseVideo) {
      setIsPlaying(true);
    }
  }, [isPauseVideo]);

  useEffect(() => {
    if (isQueueScreenVideoSoundEnabled) {
      setIsUserInteracted(true);
    }
  }, []);

  useEffect(() => {
    if (playlist.length > 0 && currentVideoIndex >= playlist.length) {
      setCurrentVideoIndex(0);
    }
  }, [playlist.length, currentVideoIndex]);

  const safeIndex = playlist.length > 0 ? Math.min(currentVideoIndex, playlist.length - 1) : 0;
  const currentUrl = playlist[safeIndex] ?? '';

  return (
    <div
      className={classNames(classes.videoPlayerWrapper, {
        [classes.videoPlayerWrapperNoRounding]: noRoundedCorners
      })}>
      <ReactPlayer
        playing={isPlaying && !isPauseVideo}
        volume={normalizedVolume}
        muted={isMuted}
        url={currentUrl}
        onEnded={handlePlayNextVideo}
        controls={isPlaying ? true : false}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        width="100%"
        height="100%"
      />

      <button
        onClick={handlePlayPause}
        className={classNames(classes.playBtn, {
          [classes.hideBtn]: isPlaying
        })}>
        <span className={classNames(classes.wave, classes.wave1)}></span>
        <span className={classNames(classes.wave, classes.wave2)}></span>
        <span className={classNames(classes.wave, classes.wave3)}></span>
        <img className={classes.imgIcon} src={queueScreenPlayBtnIcon} alt="PlayBtnIcon" />
      </button>
    </div>
  );
};

export default VideoPlayer;
